var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGolfBatIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00008 14.0001L11.0001 6.66674M11.7467 2.28207L10.7561 6.00007C10.7294 6.09947 10.7399 6.2052 10.7855 6.29746C10.8311 6.38971 10.9088 6.46219 11.004 6.50133C11.0992 6.54047 11.2053 6.54359 11.3027 6.5101C11.4 6.47662 11.4818 6.40882 11.5327 6.3194L13.4421 2.97807C13.5071 2.86406 13.5471 2.7375 13.5594 2.60682C13.5717 2.47614 13.5559 2.34434 13.5132 2.22022C13.4706 2.0961 13.4019 1.9825 13.3118 1.88701C13.2218 1.79152 13.1124 1.71633 12.991 1.66644C12.8696 1.61656 12.7389 1.59314 12.6078 1.59773C12.4766 1.60233 12.3479 1.63484 12.2303 1.6931C12.1127 1.75136 12.0088 1.83402 11.9257 1.93558C11.8425 2.03714 11.782 2.15526 11.7481 2.28207M4.98075 11.5087L8.00008 13.9827C7.74675 14.2427 7.50342 14.5094 7.14542 14.6141C6.96542 14.6667 6.77341 14.6667 6.38808 14.6667H4.43075C3.41608 14.6667 2.46408 14.3427 2.10608 13.2901C1.76942 12.3007 2.23475 10.6594 3.49275 10.6667C3.95675 10.6694 4.29808 10.9494 4.98075 11.5087Z",
    stroke: "#006AB3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGolfBatIcon);
export default __webpack_public_path__ + "static/media/golf-bat_icon.98846091416083d1e36b0d03adbc46a6.svg";
export { ForwardRef as ReactComponent };